import * as React from 'react';
import {
  Building2,
  FileText,
  HandHelping,
  Handshake,
  LayoutDashboard,
  MessageSquareQuote,
  Package,
  ReceiptText,
  TicketPercent,
} from 'lucide-react';

import NavUser from './nav-user';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from './ui/sidebar';
import NavMain from './nav-main';

// This is sample data.
const data = {
  user: {
    name: 'PT Mulia Sujar Abadi',
    email: 'm@example.com',
    avatar: '/assets/avatar.png',
  },
  home: [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: LayoutDashboard,
    },
  ],
  managements: [
    {
      title: 'Company',
      url: '/company-manage',
      icon: Building2,
    },
    {
      title: 'Service',
      url: '/service-manage',
      icon: HandHelping,
    },
    {
      title: 'Promo',
      url: '/promo-manage',
      icon: TicketPercent,
    },
    {
      title: 'Product',
      url: '/product-manage',
      icon: Package,
    },
    {
      title: 'Testimonial',
      url: '/testimonial-manage',
      icon: MessageSquareQuote,
    },
  ],
  sales: [
    {
      title: 'Invoice',
      url: '/invoice',
      icon: FileText,
    },
    {
      title: 'Receipt',
      url: '/receipt',
      icon: ReceiptText,
    },
    {
      title: 'Partner',
      url: '/partner',
      icon: Handshake,
    },
  ],
};

export default function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <img src="/assets/MSA-Logo.jpg" alt="MSA-Logo" className="rounded" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-bold text-lg">MSA Admin</span>
              </div>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.home} name="Home" />
        <NavMain items={data.managements} name="Managements" />
        <NavMain items={data.sales} name="Sales" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
